import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { RpfsaModule } from './admin-app/rpfsa.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(RpfsaModule)
	.then(() => console.info('RailPros app rising'))
	.catch((err) => console.error(err));
